import { useMemo } from 'react';

import { cn } from '@/utils/cn';

import * as Icons from '../../assets/icons';
import type { IconName } from '../../types/icon.types';

type Props = {
  className?: string;
  name: IconName;
  size?: 'sm' | 'md' | 'lg';
};

const Icon = ({ className = '', name, size = 'md' }: Props) => {
  const IconComponent = useMemo(() => Icons[name], [name]);
  return (
    <div
      className={cn(size === 'sm' ? 'h-4 w-4' : size === 'md' ? 'h-6 w-6' : 'h-8 w-8', className)}
    >
      <IconComponent />
    </div>
  );
};

export default Icon;
